// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JU8k","select":"styles_select__1roBZ"};